export default class RouteUtils {
  static get queryParams () {
    return new URLSearchParams(window.location.search)
  }

  static get (key, parse = null) {
    let toReturn = RouteUtils.queryParams.get(key)
    if (toReturn === null) return null
    if (parse !== null) toReturn = parse(toReturn)
    return toReturn
  }

  static set (key, value) {
    let queryParams = RouteUtils.queryParams
    queryParams.set(key, value)
    window.history.replaceState(window.history.state, '', `${window.location.href.split('?')[0]}?${queryParams.toString()}`)
  }

  static delete (key) {
    let queryParams = RouteUtils.queryParams
    queryParams.delete(key)
    window.history.replaceState(window.history.state, '', `${window.location.href.split('?')[0]}?${queryParams.toString()}`)
  }

  static callIfExists (key, callback, parse = null) {
    let value = RouteUtils.get(key, parse)
    if (value !== null) callback(value)
  }
}